// @flow
import styled from 'styled-components';

export const ProvincesContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;
